import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators } from "../../store/Quote";
import Pagination from '../Pagination';
import Breadcrumb from '../BreadcrumbMenu';
import Search from "../Search";
import PropTypes from "prop-types";

class QuoteList extends Component{

  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
      this.searchLoadAll = this.searchLoadAll.bind(this);
      //set search if kpiSearch was set in dashboard
      try {
          if (typeof this.props.history.location.state.kpiSearch != 'undefined') {
              this.props.setSearch(this.props.history.location.state.kpiSearch)
              this.searchLoadAll()
          }
              
      } catch { }
     
  }

  componentDidMount(){
    if (this.props.display.length === 0){
      this.props.requestQuotes();
    }
  }

  handleClick(event){
    let id = event.currentTarget.getAttribute("id");
    this.props.history.push("/services/" + id);
  }

  searchLoadAll(event){
    this.props.clearStatePreserveSearch();
    this.props.requestQuotes();
  }

  render(){
    return(
      <div>
        <Breadcrumb/>

        <div className="container-header">
          <div className="header-start">
            <h3>Quotes</h3>
          </div>
          <div className="header-end">
            <Search setSearch={this.props.setSearch} search={this.props.search} requestRecords={this.props.requestQuotes} clearState={this.props.clearState}/>
          </div>
        </div>

        <div className="centered-container border">
          <div className="container-body">
            <table className="cdb-table">
              <tbody>
              <tr>
                <th>#</th>
                <th>Status</th>
                <th>Type</th>
                <th>Location</th>
                <th>Submitted Date</th>
                <th>Total Due</th>
                <th>Image</th>
                <th>Service #</th>
              </tr>
              {this.props.display.map((quote) => {
                return(
                  <tr key={quote.id} id={quote.FileMakerId}>
                    <td>{quote.quoteNo}</td>
                    <td>{quote.status}</td>
                    <td>{quote.serviceType}</td>
                    <td>{quote.locationName}</td>
                    <td>{quote.submittedDate}</td>
                    <td>${quote.total}</td>
                    <td>
                      {quote.imageUrl ?
                      <a href={`${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${process.env.PUBLIC_URL}/document${quote.imageUrl}`}
                         target='_blank' rel='noopener noreferrer'>
                        <span className="icon-view-assignment"/>
                      </a>
                      : ''
                      }
                    </td>
                    <td style={{color: "red"}} id={quote.workOrderNo} onClick={this.handleClick}>{quote.workOrderNo}</td>
                  </tr>
                );
              })}
              </tbody>
            </table>
          </div>
        </div>

        {this.props.search !== '' && !this.props.paginate ?
          <div style={{display: 'flex', justifyContent: 'center'}}>
            <button className="btn-primary btn-lg" onClick={this.searchLoadAll}
                    style={{width: '200px'}}>Load All Results
            </button>
          </div>
          : ''
        }

        {this.props.paginate ?
          <Pagination paginateFunc={this.props.requestQuotes} currentPage={this.props.currentPage}
                      pageCount={this.props.pageCount}/>
          : ''
        }
      </div>
    );
  }
}

QuoteList.propTypes = {
  display: PropTypes.array.isRequired,
  currentPage: PropTypes.number.isRequired,
  pageCount: PropTypes.number.isRequired,
  requestQuotes: PropTypes.func.isRequired,
  search: PropTypes.string,
  setSearch: PropTypes.func.isRequired,
  clearState: PropTypes.func.isRequired,
  clearStatePreserveSearch: PropTypes.func.isRequired,
  paginate: PropTypes.bool.isRequired
};

function mapStateToProps(state){
  return {
    display: state.quotes.display,
    currentPage: state.quotes.page,
    pageCount: state.quotes.pageCount,
    search: state.quotes.search,
    paginate: state.quotes.paginate
  }
}

export default connect(mapStateToProps,
  dispatch => bindActionCreators(actionCreators, dispatch))(QuoteList);